<template>
	<div>
		<div class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<h1 class="text-center mt-3">Choose Authentication Method</h1>
			<p class="text-center text-muted mt-1 mb-0">Choose a second authentication method. This is used to offer a second layer of protection for your account.</p>
			<p class="text-muted">Email Based Two-Factor Authentication will be enabled by default.</p>

			<div>
				<BoxChoicesGeneral :data="authenticators" :show-error="false" @question-answered="handleAuthenticatorChoice"></BoxChoicesGeneral>
			</div>

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('skip')">skip for now</button>
				<button class="btn btn-dark rounded-pill py-7" :disabled="selectedAuthenticator == null" :class="width < 992 ? 'w-75' : 'w-50'" @click="moveButtonAction('two-factor-download')">Continue</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from "vue";
import BoxChoicesGeneral from "@/components/BoxChoicesGeneral.vue";

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});

const emits = defineEmits(['navigationButtonClicked']);
const moveButtonAction = (name) => {
	emits('navigationButtonClicked', name);
}

const authenticators = ref(
	{
		options: [
			{ iconClass: 'bi-upc-scan', label: 'Authenticator App', description: null },
			// { iconClass: 'bi-envelope-at', label: 'Authenticate via Email', description: null },
			// { iconClass: 'bi-phone', label: 'Authenticate via SMS', description: null }
		]
	}
);

const selectedAuthenticator = ref(null);

const handleAuthenticatorChoice = (choice) => {
	if(choice) {
		selectedAuthenticator.value = choice;
		// Do something with the choice
	}
};

</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>